module.exports = __webpack_public_path__ + "static/media/image8.fcabb1d8.jpg";